import * as Types from '../../../../__generated__/schema';

import { Notification } from '../../../graphql/fragments/Notification.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateNotificationVariables = Types.Exact<{
  input: Types.UpdateNotificationInput;
}>;

export type UpdateNotification = { updateNotification: Notification };

export const UpdateNotificationDocument = gql`
  mutation UpdateNotification($input: UpdateNotificationInput!) {
    updateNotification(input: $input) {
      ...Notification
    }
  }
  ${Notification}
`;
export type UpdateNotificationMutationFn = Apollo.MutationFunction<
  UpdateNotification,
  UpdateNotificationVariables
>;

/**
 * __useUpdateNotification__
 *
 * To run a mutation, you first call `useUpdateNotification` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotification` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotification, { data, loading, error }] = useUpdateNotification({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotification(
  baseOptions?: Apollo.MutationHookOptions<UpdateNotification, UpdateNotificationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateNotification, UpdateNotificationVariables>(
    UpdateNotificationDocument,
    options,
  );
}
export type UpdateNotificationHookResult = ReturnType<typeof useUpdateNotification>;
export type UpdateNotificationMutationResult = Apollo.MutationResult<UpdateNotification>;
export type UpdateNotificationMutationOptions = Apollo.BaseMutationOptions<
  UpdateNotification,
  UpdateNotificationVariables
>;
export function mockUpdateNotification({
  data,
  variables,
  errors,
}: {
  data: UpdateNotification;
  variables?: UpdateNotificationVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: UpdateNotificationDocument, variables },
    result: { data, errors },
  };
}
